/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Pit3_TInputs */

const en_sorter_pit3_t = /** @type {(inputs: Sorter_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorting before diffing helps, but only for objects`)
};

const ko_sorter_pit3_t = /** @type {(inputs: Sorter_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diff 전에 정렬하는 것은 도움이 되지만 객체에 한합니다`)
};

const ja_sorter_pit3_t = /** @type {(inputs: Sorter_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差分の前に並べ替えるのは有効ですが、オブジェクトに限ります`)
};

/**
* | output |
* | --- |
* | "Sorting before diffing helps, but only for objects" |
*
* @param {Sorter_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_pit3_t = /** @type {((inputs?: Sorter_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_pit3_t(inputs)
	if (locale === "ko") return ko_sorter_pit3_t(inputs)
	return ja_sorter_pit3_t(inputs)
});